import { render, staticRenderFns } from "./TaskTodoItem.vue?vue&type=template&id=26b51a05&"
import script from "./TaskTodoItem.vue?vue&type=script&lang=js&"
export * from "./TaskTodoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports